<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-11-14 09:43:51
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-11-19 14:05:55
 * @FilePath: \H5\src\views\Look.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="look">
    
      <Sertificate />
    
  </div>
</template>

<script>
import Sertificate from "@/components/Sertificate";

export default {
  data() {
    return {};
  },
  components: {
    Sertificate,
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  //方法
  methods: {},
};
</script>
<style lang="scss" scoped>
.look {
  padding: 48px 32px;
}
</style>
